export default window.IntersectionObserver;
